"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _themeOptions = require("../../helpers/theme-options");

var _contentUi = _interopRequireDefault(require("../content/content-ui"));

var _const = require("../../const");

var _helpers = require("./helpers");

var _mediaParagraph = require("./media-paragraph.styled");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaParagraph = function MediaParagraph(_ref) {
  var id = _ref.id,
      removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding,
      layout = _ref.layout,
      _ref$theme = _ref.theme,
      currentTheme = _ref$theme === void 0 ? _themeOptions.ThemeBlockVariants.WHITE : _ref$theme,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      children = _ref.children;
  var isBlock = currentTheme ? _themeOptions.themeBlockCardStrategy[currentTheme].isBlock : false;
  var isDarkTheme = !isBlock && _themeOptions.themeBlockCardStrategy[currentTheme].type === _themeOptions.ThemeType.DARK;
  var theme = {
    $theme: currentTheme,
    isBlock: isBlock,
    isDarkTheme: isDarkTheme,
    removeTopPadding: removeTopPadding,
    removeBottomPadding: removeBottomPadding
  };
  var buttonColor = isDarkTheme ? 'secondaryLight' : 'gray800';
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_mediaParagraph.BoxStyled, {
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_MEDIA_PARAGRAPH,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Container, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    sm: 12,
    lg: (0, _helpers.getColumns)(layout)
  }, /*#__PURE__*/_react.default.createElement(_mediaParagraph.WrappStyled, null, /*#__PURE__*/_react.default.createElement(_contentUi.default, null, children), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    color: buttonColor
  })))))));
};

var _default = MediaParagraph;
exports.default = _default;